module.exports = __webpack_public_path__ + "static/media/clay.f989b24a.mp3";